/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';

import _service from '@netuno/service-client';
import _ws from '@netuno/ws-client';

import Interaction from './containers/Interaction/index.jsx';
import Footer from './containers/Footer/index.jsx';
import Loading from './containers/Loading/index.jsx';
import Core from "./Core";
import config from "./config";

import './App.less';

_service.config({
  prefix: config.services.endpoint
});

function App() {
  const [invalid, setInvalid] = useState(false);
  const [connecting, setConnecting] = useState(true);
  const [connected, setConnected] = useState(false);
  const [closed, setClosed] = useState(false);
  const [data, setData] = useState(null);
  const [forceDisconnect, setForceDisconnect] = useState(false)
  const [inactivity, setInactivity] = useState(false)

  const timer = {
    timer: null,
    timerScreen: null,
    stop: () => {
      if (timer.timer) {
        if (timer.timerScreen) {
          _ws.sendService({
            service: 'ws/remote/command',
            data: {
              type: JSON.stringify({
                type: "timeout-off",
                city_uid: "",
                price_min: "",
                price_max: "",
              })
            }
          });
        }
        clearTimeout(timer.timer);
        clearTimeout(timer.timerScreen);
        timer.timer = null;
        timer.timerScreen = null;
      }
    },
    start: () => {
      if (!timer.timer) {
        timer.stop();
        timer.timer = setTimeout(() => {
          _ws.sendService({
            service: 'ws/remote/command',
            data: {
              type: JSON.stringify({
                type: "timeout-on",
                city_uid: "",
                price_min: "",
                price_max: "",
              })
            }
          });
          timer.timerScreen = setTimeout(() => {
            setInactivity(true)
            timer.stop();
            _ws.close();
          }, 5000);
        }, (config.sessionIdleTime * 1000));
      }
    }, reset: () => {
      timer.stop();
      timer.start();
    }
  };

  useEffect(() => {
    if (connected && !forceDisconnect) {
      timer.start();
      window.addEventListener("click", () => { timer.reset(); });
      window.addEventListener("scroll", () => { timer.reset(); });
      window.addEventListener("mousemove", () => { timer.reset(); });
      window.addEventListener("touchstart", () => { timer.reset(); });
      if (window.innerWidth <= 640) {
        window.onblur = () => {
          _ws.close()
        }
      }
      setTimeout(() => {
        _ws.sendService({
          service: 'ws/remote/command',
          data: {
            type: JSON.stringify({
              type: "timeout-forced-on",
              city_uid: "",
              price_min: "",
              price_max: "",
            })
          }
        });
        setTimeout(() => {
          _ws.sendService({
            service: 'ws/remote/command',
            data: {
              type: JSON.stringify({
                type: "timeout-forced-off",
                city_uid: "",
                price_min: "",
                price_max: "",
              })
            }
          });
          _ws.close();
        }, 5000);
      }, 900000)
    }
    else if (connected && forceDisconnect) {
      timer.start()
      window.removeEventListener("click")
      window.removeEventListener("scroll")
      window.removeEventListener("mousemove")
      window.removeEventListener("touchstart")
    }
  }, [connected, forceDisconnect]);

  useEffect(() => {
    let interactionCode = '';
    if (window.location.hash && window.location.hash !== "") {
      interactionCode = window.location.hash.substring(1);
    } else if (window.location.pathname !== '/') {
      interactionCode = window.location.pathname.substring(1);
    }
    if (interactionCode !== '') {
      _ws.config({
        url: `${config.ws.endpoint}/${interactionCode}`,
        servicesPrefix: '/services',
        connect: (event) => {
          setConnecting(false);
          setConnected(true);
        },
        close: (event) => {
          _ws.close();
          setConnecting(false);
          setConnected(false);
          setClosed(true);
        }
      });

      const wsStartListenerRef = _ws.addListener({
        service: "remote/start",
        success: (message) => {
          setData(message.content);
        },
        fail: (error) => {
          console.error("ws:listener # service: remote/start", error);
        }
      });

      _ws.connect();

      return () => {
        _ws.removeListener(wsStartListenerRef);
      };
    } else {
      setInvalid(true);
    }
  }, []);

  let failMessage = '';
  if (invalid) {
    failMessage = 'Link inválido!';
  } else if (closed) {
    failMessage = inactivity ? "Desligado por inatividade do utilizador." : 'Desligado.';
  } else if (!connected) {
    failMessage = 'A ligar...';
  }
  if (failMessage !== '') {
    return (
      <div>
        <div className="app-fail">
          <div className="app-fail__container">
            <h2>{failMessage}</h2>
          </div>
        </div>
        <Footer width="100%" data={connected ? data : null} />
      </div>
    );
  }
  if (connecting || data == null) {
    return (
      <Loading />
    );
  }
  return (
    <div className="App">
      <Interaction data={data} />
    </div>
  );
}

export default App;
